export default __webpack_public_path__ + "static/media/7802e576-2ffa-4f22-a409-534355fbea79.b1dce775.woff";